import { render, staticRenderFns } from "./ArticleBox.vue?vue&type=template&id=c490655a&"
import script from "./ArticleBox.js?vue&type=script&lang=js&"
export * from "./ArticleBox.js?vue&type=script&lang=js&"
import style0 from "./ArticleBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ArticleBox.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fcontent%2FArticleBox%2FArticleBox.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports